import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { TextField } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useCreateCompany } from "../../../hooks/useCreateCompany";
import { useUpdateCompany } from "../../../hooks/useUpdateCompany";
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';
import TierSelect from '../controls/TierSelect';

export default function CompanyForm({ setCompanies, company = null, mode = "create", open, onClose }) {

    const { t } = useTranslation('common'); 

    const [name, setName] = React.useState(company ? company.name : "");
    const [tier, setTier] = React.useState(company ? company.tier : "");

    const { create } = useCreateCompany(setCompanies);
    const { update } = useUpdateCompany(setCompanies);

    const { showSnackbar } = useSnackbar();

    React.useEffect(() => {
        // reset field when company changes (e.g. when opening edit)
        setName(company ? company.name : "");
        setTier(company ? company.tier : "")
    }, [company, open]);

    const handleSave = async () => {
        if (!name.trim()) {
            showSnackbar(t('companies.messages.name_required'), "warning");
            return;
        }
        if (!tier) {
            showSnackbar(t('companies.messages.tier_required'), "warning");
            return;
        }

        try 
        {
            if (mode === "create") {
                await create({ name, tier });
                showSnackbar(t('companies.messages.create_success'), "success");
            } else if (mode === "edit" && company) {
                await update(company.id, { name, tier });
                showSnackbar(t('companies.messages.update_success'), "success");
            }
            setName("");
            setTier("");
            onClose();     // close dialog
        } catch (err) {
            showSnackbar(t('companies.messages.save_fail'), "error");
        }

    };

    const handleCancel = () => {
        setName("");
        setTier("");
        onClose();
    };

    return (
        <Dialog onClose={handleCancel} open={open} disableRestoreFocus>
        <DialogTitle>{mode === "create" ? "Add Company" : "Edit Company"}</DialogTitle>

        <DialogContent dividers>
            <Stack spacing={1}>
            <TextField
                label="Company Name"
                variant="outlined"
                value={name}
                onChange={(e) => setName(e.target.value)}
                fullWidth
            />
            <TierSelect
             value={tier} 
             onChange={(e) => setTier(e.target.value)}
            />
            </Stack>
        </DialogContent>

        <DialogActions>
            <Button onClick={handleSave}>Save</Button>
            <Button onClick={handleCancel}>Cancel</Button>
        </DialogActions>
        </Dialog>
    );
}